import { render, staticRenderFns } from "./HotArticles.vue?vue&type=template&id=304e867f&scoped=true"
import script from "./HotArticles.vue?vue&type=script&lang=js"
export * from "./HotArticles.vue?vue&type=script&lang=js"
import style0 from "./HotArticles.vue?vue&type=style&index=0&id=304e867f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304e867f",
  null
  
)

export default component.exports